import TagRouter from '../tag/@config/router';
import SocialRouter from '../social/@config/router';
import ShippingRouter from '../shipping/@config/router';
import TagReviewRouter from '../tagReview/@config/router';
import CancelReasonRouter from '../cancelReason/@config/router';

export default {
    path: 'setting',
    component: () => import('../Setting.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách cấu hình',
            redirect: '/setting/general'
        },
        {
            path: 'general',
            name: 'Cấu hình chung',
            component: () => import('../general/General.vue')
        },
        {
            path: 'address',
            name: 'Chi nhánh - Cửa hàng',
            component: () => import('../address/Address.vue')
        },
        {
            path: 'warehouse',
            name: 'Kho hàng',
            component: () => import('../warehouse/Warehouse.vue')
        },
        {
            path: 'payment-method',
            name: 'Phương thức thanh toán',
            component: () => import('../paymentMethod/PaymentMethod.vue')
        },
        {
            path: 'notification',
            name: 'Thông báo',
            component: () => import('../notification/Notification.vue')
        },
        {
            path: 'config-size',
            name: 'Cấu hình size',
            component: () => import('../configSize/ConfigSize.vue')
        },
        CancelReasonRouter,
        TagReviewRouter,
        ShippingRouter,
        SocialRouter,
        TagRouter,
    ]
};